import type { Vehicle } from '../../Entities/Vehicle/Vehicle.entity';

export const isHeycarConnectDealer = (vehicle: Vehicle | null) =>
  vehicle?.eligibleProducts?.includes('HEYCAR_CONNECT');

export const isHeycarConnectStaticFinanceDealer = (vehicle: Vehicle | null) =>
  vehicle?.eligibleProducts?.includes('HEYCAR_CONNECT_STATIC_FINANCING_PRECALC');
